import * as Yup from "yup";

import { analytics } from "./firebase";
import { countryData } from "./countryData";

export const formSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email")
    .required("Required"),
  country: Yup.string()
    .min(1, "Please select your country")
    .required("Required")
});

export const setInitialValues = () => {
  const params = new URLSearchParams(window.location.search);
  const countryParam = params.get("country")
    ? params.get("country").toUpperCase()
    : null;

  const deafultCountryObj = countryData.find(
    country => country.code === countryParam
  );

  const initialValues = {
    email: "",
    country: deafultCountryObj ? deafultCountryObj.name : ""
  };

  if (deafultCountryObj) {
    analytics.logEvent("detect_country", {
      country: deafultCountryObj.name
    });
  }

  return initialValues;
};
